import React from 'react'
import styled from 'react-emotion'

const ScrollOuter = styled.div`
  overflow-y: hidden;
  overflow-x: scroll;
`

const ScrollInner = styled.div`
  width: 200%;
  display: flex;
  flex-direction: row;
  height: 100%;
`

const ScrollItem = styled.div`
  flex-basis: 80vw;
  margin-left: 10px;
  height: 100%;

  &:last-child {
    margin-right: 50px;
  }

  @media (min-width: 450px) {
    flex-basis: 40vw;
  }
`

const ScrollContainer = ({ children, className, itemStyle }) => {
	const count = React.Children.count(children)
	return (
		<ScrollOuter className={className}>
			<ScrollInner>
				{React.Children.map(children, child => (
					<ScrollItem
						count={count}
						style={{
							...itemStyle(child)
						}}
					>
						{child}
					</ScrollItem>
				))}
			</ScrollInner>
		</ScrollOuter>
	)
}

export default ScrollContainer
